<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" title="Contents">
<h2 class="fmhead"><a id="page_v"></a>Contents</h2>
<p class="toc"><a href="#/xhtml/front01">Note on Romanization</a></p>
<p class="toc"><a href="#/xhtml/front02">Abbreviations</a></p>
<p class="toc"><a href="#/xhtml/introduction">Introduction: Conceiving State Violence, Justice, and Transition in East Asia</a></p>
<p class="toc1">Sung Chull Kim and N. Ganesan</p>
<p class="toc"><a href="#/xhtml/chapter01">1. Interpreting State Violence in Asian Settings</a></p>
<p class="toc1">Vince Boudreau</p>
<p class="toc"><span href="#/xhtml/chapter02" title="Link target outside of Sample">2. From the Streets to the National Assembly: Democratic Transition and Demands for Truth about Kwangju in South Korea</span></p>
<p class="toc1">Namhee Lee</p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">3. Unsettled State Violence in Japan: The Okinawa Incident</span></p>
<p class="toc1">Hayashi Hirofumi</p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">4. Popular Views of State Violence in China: The Tiananmen Incident</span></p>
<p class="toc1">Jeffrey N. Wasserstrom and Kate Merkel-Hess</p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">5. Mass Atrocities in Cambodia under the Khmer Rouge Reign of Terror</span></p>
<p class="toc1">Sorpong Peou</p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">6. Counterrevolutionary Violence in Indonesia</span></p>
<p class="toc1">Douglas Kammen</p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">7. Getting Away with Murder in Thailand: State Violence and Impunity in Phatthalung</span></p>
<p class="toc1">Tyrell Haberkorn</p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample">8. The End of an Illusion: The Mendiola Massacre and Political Transition in Post-Marcos Philippines</span></p>
<p class="toc1">Rommel A. Curaming</p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample">9. The Four-Eights Democratic Movement and Political Repression in Myanmar</span></p>
<p class="toc1">Kyaw Yin Hlaing</p>
<p class="toc"><a id="page_vi"></a><span href="#/xhtml/chapter10" title="Link target outside of Sample">Conclusion: Comparing State Violence and Reconciliation across East Asia</span></p>
<p class="toc1">N. Ganesan and Sung Chull Kim</p>
<p class="toc"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/contributors" title="Link target outside of Sample">List of Contributors</span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?494e2ed3